export const COMPUTE_FUNCTION_NAMES = {
  DARKEN: "darken",
  BRIGHTEN: "brighten"
};
